module.exports = __webpack_public_path__ + "img/face3.73bfbe93.png";